/**
 *
 * MsTeamsPresenceForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DetailHeader, InputField } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
   margin-left: 35px;
 `;

export default function MsTeamsPresenceForm({ isSaving, inherited }) {

  return (
    <Wrapper>
      <DetailWrapper open data-automation="msteamsPresencePropertiesSVG">
        <WrappedDetailHeader text="Properties" />
        <InputField
          name="properties.msTenantId"
          label="MS Tenant ID"
          componentType="input"
          inputType="text"
          data-automation="integrationsMsTenantId"
          disabled={isSaving || inherited}
        />
        <InputField
          name="properties.msClientId"
          label="MS Client/Application ID"
          componentType="input"
          inputType="text"
          data-automation="integrationsMsClientId"
          disabled={isSaving || inherited}
        />
      </DetailWrapper>
    </Wrapper>
  );
}

MsTeamsPresenceForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
  sidePanelUpdatePermissions: PropTypes.object
};

MsTeamsPresenceForm.defaultProps = {
};
